module.exports = __webpack_public_path__ + "img/face-nose-steam.cd4f2ee8.svg";